import PageWrapper from "../page-wrapper/page-wrapper.components";
import { FolderOpen } from "lucide-react";

const DocumentCard = ({ href, imageSrc, title }) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="block group"
    >
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all">
            <div className="aspect-[4/3] overflow-hidden bg-gray-100">
                <img
                    src={imageSrc}
                    alt={title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
            </div>
            <div className="p-3">
                <p className="text-sm font-medium text-gray-700 group-hover:text-primary transition-colors line-clamp-2">
                    {title}
                </p>
            </div>
        </div>
    </a>
);

const DocumentSection = ({ title, documents }) => (
    <div className="mb-8">
        <h5 className="text-lg font-semibold text-gray-900 mb-4">{title}</h5>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {documents.map((doc, index) => (
                <DocumentCard key={index} {...doc} />
            ))}
        </div>
    </div>
);

const MarketingPage = () => {
    const sections = [
        {
            title: "General",
            documents: [
                { href: "/files/Why Choose NHC.pdf", imageSrc: "/thumbnails/HSAFeatures.png", title: "Why Choose NHC" },
                { href: "/files/Why Add a Spending Account.pdf", imageSrc: "/thumbnails/SpendingAccountThumbnail.png", title: "Why Add a Spending Account" },
                { href: "/files/Scheduled Credits.pdf", imageSrc: "/thumbnails/ScheduledCredits.png", title: "Scheduled Credits" },
                { href: "/files/Benefit Proposal Generic.pdf", imageSrc: "/thumbnails/Benefit Proposal Generic.png", title: "Who is NHC" },
                { href: "/files/What you get for the admin fee.pdf", imageSrc: "/thumbnails/AdminFee.png", title: "What you get for the admin fee" },
            ]
        },
        {
            title: "Business Owner Health Spending Accounts",
            documents: [
                { href: "/files/Business Owner - HSA Benefit Solution - Detailed.pdf", imageSrc: "/thumbnails/LongCopy.png", title: "Business Owner - HSA Benefit Solution - Detailed" },
                { href: "/files/Business Owner - HSA Tax Savings - Alberta.pdf", imageSrc: "/thumbnails/HSATaxSavings.png", title: "Business Owner - HSA Tax Savings" },
                { href: "/files/Business Owner - HSA Tax Savings - Ontario.pdf", imageSrc: "/thumbnails/OntarioHSATaxSavings.png", title: "Business Owner - HSA Tax Savings - Ontario" },
                { href: "/files/Business Owner - HSA Tax Savings - Atlantic.pdf", imageSrc: "/thumbnails/AtlanticHSATaxSavings.png", title: "Business Owner - HSA Tax Savings - Atlantic" },
            ]
        },
        {
            title: "Health Spending Account",
            documents: [
                { href: "/files/HSA One Pager.pdf", imageSrc: "/thumbnails/HSAOnePager.png", title: "HSA One Pager" },
                { href: "/files/HSA Detailed.pdf", imageSrc: "/thumbnails/HSADetailed.png", title: "HSA Detailed" },
                { href: "/files/Complete HSA Eligible Expenses Guide.pdf", imageSrc: "/thumbnails/HSAEligibleExpensesGuide.png", title: "Complete HSA Eligible Expenses Guide" },
                { href: "/files/HSA Eligible Expenses One Page.pdf", imageSrc: "/thumbnails/HSAEligibleExpensesOnePage.png", title: "HSA Eligible Expenses One Page" },
                { href: "/files/Enhanced Benefits HSA.pdf", imageSrc: "/thumbnails/EB_HSA.png", title: "Enhanced Benefits (HSA+)" },
            ]
        },
        {
            title: "Lifestyle Spending Account",
            documents: [
                { href: "/files/Lifestyle Spending - Stand Alone.pdf", imageSrc: "/thumbnails/LifestyleSpendingAccountOnly.png", title: "Lifestyle Spending Account - Stand Alone" },
                { href: "/files/Lifestyle Spending - Plus Health Spending.pdf", imageSrc: "/thumbnails/LifestyleSpending.png", title: "Lifestyle Spending Account + Health Spending" },
                { href: "/files/Lifestyle Spending - RSP.pdf", imageSrc: "/thumbnails/LifestyleSpending.png", title: "Lifestyle Spending - RSP" },
                { href: "/files/LSA Category List (View Only).pdf", imageSrc: "/thumbnails/LSA Category List View.png", title: "LSA Category List" },
                { href: "/files/Enhanced Benefits LSA.pdf", imageSrc: "/thumbnails/EB_LSA.png", title: "Enhanced Benefits (LSA+)" },
            ]
        },
        {
            title: "CoreHealth+",
            documents: [
                { href: "/files/CoreHealth Brochure.pdf", imageSrc: "/thumbnails/BrochureOnly.png", title: "Brochure Only" },
                { href: "/files/CoreHealth Plus Summary Highlights.pdf", imageSrc: "/thumbnails/CHSummaryDocument.png", title: "CH+ Summary Highlights" },
            ]
        },
        {
            title: "Working With NHC",
            documents: [
                { href: "/files/The Business Owner Journey.pdf", imageSrc: "/thumbnails/BOthumbnail.png", title: "The Business Owner Journey" },
                { href: "/files/The Employee Journey.pdf", imageSrc: "/thumbnails/EEthumbnail.png", title: "The Employee Journey" },
                { href: "/files/The PA Journey.pdf", imageSrc: "/thumbnails/PAthumbnail.png", title: "The PA Journey" },
                { href: "/files/What PAs can expect with NHC on an HSA Plan.pdf", imageSrc: "/thumbnails/PAExpectations.png", title: "What PAs can expect with NHC on an HSA Plan" },
            ]
        },
        {
            title: "Plan Administrator (PA) Documents",
            documents: [
                { href: "/files/PlanAdministrator(PA)-Handbook.pdf", imageSrc: "/thumbnails/PAHandbook.png", title: "Plan Admin Handbook" },
            ]
        },
        {
            title: "Employee Documents",
            documents: [
                { href: "/files/Employee HSA User Handbook.pdf", imageSrc: "/thumbnails/HealthSpendingAccount.png", title: "HSA Employee Handbook" },
                { href: "/files/Employee LSA User Handbook.pdf", imageSrc: "/thumbnails/LifestyleSpendingAccount.png", title: "LSA Employee Handbook" },
            ]
        },
    ];

    return (
        <PageWrapper>
            <div className="flex-1 px-6 md:px-12 lg:pl-12 lg:pr-24 py-6 pb-5 overflow-y-auto">
                {/* page header with icon */}
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-primary/10 rounded-xl">
                        <FolderOpen className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
                            Marketing Materials
                        </h1>
                        <p className="text-sm text-gray-500">
                            Documents and brochures
                        </p>
                    </div>
                </div>

                {/* content */}
                <div className="bg-white rounded-2xl shadow-card p-6">
                    {sections.map((section, index) => (
                        <DocumentSection key={index} {...section} />
                    ))}
                </div>
            </div>
        </PageWrapper>
    );
};

export default MarketingPage;
